import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/bus.png'


const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "flex flex-col justify-center p-8" }
const _hoisted_3 = { id: "nav" }
const _hoisted_4 = { style: {"list-style":"none"} }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { id: "group" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "mt-8 text-2xl font-semibold" }, [
  /*#__PURE__*/_createTextVNode(" おでかけ号"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("写真アプリへようこそ！ ")
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", {
  alt: "Bus logo",
  src: _imports_0,
  class: "mt-10 flex h-40 w-full object-contain"
}, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("button", { class: "mt-8 flex h-20 w-10/12 items-center justify-center rounded-md bg-sky-400 py-3 text-center text-2xl font-semibold text-black hover:bg-sky-500 hover:text-white" }, " ここを押して はじめる ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          to: `/${_ctx.groupId}`
        }, {
          default: _withCtx(() => [
            _createTextVNode("Home")
          ]),
          _: 1
        }, 8, ["to"]),
        _createTextVNode(" | "),
        _createVNode(_component_router_link, {
          to: `/${_ctx.groupId}/about`
        }, {
          default: _withCtx(() => [
            _createTextVNode("About")
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("li", _hoisted_4, [
          _createTextVNode(_toDisplayString(_ctx.groupAlias) + " ", 1),
          _hoisted_5
        ])
      ]),
      _hoisted_6,
      _hoisted_7,
      _createVNode(_component_router_link, {
        to: `/${_ctx.groupId}/signin`,
        class: "flex w-full items-center justify-center"
      }, {
        default: _withCtx(() => [
          _hoisted_8
        ]),
        _: 1
      }, 8, ["to"])
    ])
  ]))
}